/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type IdentityType = typeof IdentityType[keyof typeof IdentityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentityType = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
} as const;
